export const createInString = (strings: string[]) =>
  `['${strings.join("','")}']`;
